import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "w-full print:w-full pa-4"
};
const _hoisted_2 = {
  class: "no-print mb-2"
};
const _hoisted_3 = {
  class: "text-body-2"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "mb-2"
};
const _hoisted_6 = {
  class: "mb-2 flex flex-wrap gap-2"
};
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_8 = {
  key: 1,
  class: "conflict-check-user mb-0 pa-2 bg-gray-50 rounded"
};
const _hoisted_9 = {
  class: "flex flex-col gap-1 mb-2"
};
const _hoisted_10 = {
  class: "text-sm"
};
const _hoisted_11 = {
  class: "text-sm"
};
const _hoisted_12 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_13 = {
  class: "text-h6 mb-1"
};
const _hoisted_14 = {
  key: 0,
  class: "text-body-2 italic"
};
const _hoisted_15 = {
  key: 1,
  class: "mb-3"
};
const _hoisted_16 = {
  key: 0,
  class: "text-body-2 italic"
};
const _hoisted_17 = {
  key: 2,
  class: "mb-3"
};
const _hoisted_18 = {
  key: 0,
  class: "text-body-2 italic"
};
const _hoisted_19 = {
  class: "scrollable"
};
const _hoisted_20 = {
  key: 0,
  class: "text-center pa-4"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = ["href"];
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = {
  key: 2
};
const _hoisted_27 = {
  key: 3
};
const _hoisted_28 = {
  key: 4
};
const _hoisted_29 = {
  key: 5
};
const _hoisted_30 = {
  key: 6
};
const _hoisted_31 = {
  key: 7
};
const _hoisted_32 = {
  key: 8
};
const _hoisted_33 = {
  key: 9
};
const _hoisted_34 = {
  class: "list-none pa-0 ma-0"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  key: 1
};
const _hoisted_38 = {
  key: 4,
  class: "text-center pa-4 text-grey"
};
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import RouteService from '@/services/RouteService';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'ConflictCheck',
  props: {
    leanLawApi: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const {
      getSupportUrl: _getSupportUrl
    } = useSupportChat();
    const conflictCheckSupportUrl = computed(() => _getSupportUrl('conflictCheck'));

    // Define props for Angular services (maintains compatibility during migration)
    const props = __props;

    // Initialize Pinia stores
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);

    // Initialize route service
    const routeService = new RouteService({
      state: props.state,
      stateParams: props.stateParams,
      rootScope: props.rootScope
    });

    // Convert $scope variables to reactive state
    const query = ref('');
    const componentState = reactive({
      searching: false,
      date: new Date(),
      results: {},
      selectedDetail: null,
      detailLoading: false,
      detailType: null
    });

    // Computed properties
    const sortedUsers = computed(() => {
      if (!componentState.selectedDetail?.users) return [];

      // Sort users so the responsible user (primary: true) appears first
      return [...componentState.selectedDetail.users].sort((a, b) => {
        if (a.primary && !b.primary) return -1;
        if (!a.primary && b.primary) return 1;
        return 0;
      });
    });

    // Methods
    const search = async (q, options) => {
      if (!q) {
        componentState.results = {};
        // Clear detail panel when clearing search
        componentState.selectedDetail = null;
        componentState.detailType = null;
        componentState.detailLoading = false;
        return;
      }
      const request = options || {};
      request.query = q;
      componentState.searching = true;

      // Clear previous detail selection when starting new search
      componentState.selectedDetail = null;
      componentState.detailType = null;
      componentState.detailLoading = false;
      try {
        const results = await props.leanLawApi.search(request);
        componentState.results = results;

        // Navigate to base conflict state
        routeService.go('conflict');
      } catch (error) {
        console.error('Search error:', error);
        if (props.alerts) {
          props.alerts.error('Search failed: ' + error.message);
        }
      } finally {
        componentState.searching = false;
      }
    };
    const formatDate = date => {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit'
      });
    };
    const printPage = () => {
      window.print();
    };
    const isDetailActive = (type, id) => {
      return componentState.detailType === type && componentState.selectedDetail?.id === id;
    };

    // Methods to load detail data
    const loadClientDetail = async clientId => {
      componentState.detailLoading = true;
      componentState.detailType = 'client';
      try {
        const result = await props.leanLawApi.getClient({
          id: clientId
        });
        componentState.selectedDetail = result;
      } catch (error) {
        console.error('Failed to load client detail:', error);
        if (props.alerts) {
          props.alerts.error('Failed to load client details');
        }
      } finally {
        componentState.detailLoading = false;
      }
    };
    const loadMatterDetail = async matterId => {
      componentState.detailLoading = true;
      componentState.detailType = 'matter';
      try {
        const result = await props.leanLawApi.getMatter({
          id: matterId
        });
        componentState.selectedDetail = result;
      } catch (error) {
        console.error('Failed to load matter detail:', error);
        if (props.alerts) {
          props.alerts.error('Failed to load matter details');
        }
      } finally {
        componentState.detailLoading = false;
      }
    };
    const loadEntryDetail = async entryId => {
      componentState.detailLoading = true;
      componentState.detailType = 'entry';
      try {
        const result = await props.leanLawApi.getEntry({
          id: entryId
        });
        componentState.selectedDetail = result;
      } catch (error) {
        console.error('Failed to load entry detail:', error);
        if (props.alerts) {
          props.alerts.error('Failed to load entry details');
        }
      } finally {
        componentState.detailLoading = false;
      }
    };

    // Navigation methods to info pages
    const navigateToClient = clientId => {
      routeService.go('clients.client.view.info', {
        id: clientId
      });
    };
    const navigateToMatter = matterId => {
      // For matter navigation, we need both client ID and matter ID
      const clientId = componentState.selectedDetail?.client?.id;
      if (clientId) {
        routeService.go('clients.client.matter.info', {
          id: clientId,
          matterId: matterId
        });
      } else {
        console.error('Cannot navigate to matter: missing client ID');
        if (props.alerts) {
          props.alerts.error('Cannot navigate to matter: missing client information');
        }
      }
    };

    // Lifecycle
    onMounted(async () => {
      // Load current user data via Pinia store
      try {
        await meStore.getMe();
      } catch (error) {
        console.error('Failed to load user data:', error);
      }

      // Ensure we're on the conflict route
      if (props.state?.current?.name !== "conflict") {
        routeService.go('conflict');
      }
    });
    onBeforeUnmount(() => {
      // Cleanup will be handled automatically by Vue's lifecycle
    });
    return (_ctx, _cache) => {
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_table = _resolveComponent("v-table");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("h3", {
        class: "text-h5 mb-2"
      }, "Conflict Check", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_cache[10] || (_cache[10] = _createTextVNode(" The conflict check searches specific fields in clients and matters for the keyword(s) specified. ", -1)), _createElementVNode("a", {
        href: conflictCheckSupportUrl.value,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "text-primary underline"
      }, " Click here ", 8, _hoisted_4), _cache[11] || (_cache[11] = _createTextVNode(" for more information on what is searched. To search time entry descriptions, select \"Search Time Entries\" instead. ", -1))])]), _createVNode(_component_v_form, {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers($event => search(query.value), ["prevent"])),
        class: "w-full mb-3"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_v_textarea, {
          modelValue: query.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value = $event),
          rows: "5",
          variant: "outlined",
          class: "w-full",
          style: {
            "width": "90%"
          },
          "hide-details": "",
          "data-cy": "search-textarea"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(LlSecondaryButton, {
          type: "submit",
          color: "primary",
          class: "mr-2",
          disabled: !query.value?.length || query.value.length < 2,
          onClick: _cache[1] || (_cache[1] = $event => search(query.value)),
          "data-cy": "search-clients-matters"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Search Clients and Matters ", -1)]))]),
          _: 1
        }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
          variant: "outlined",
          class: "mx-2",
          disabled: !query.value?.length || query.value.length < 4,
          onClick: _cache[2] || (_cache[2] = $event => search(query.value, {
            clients: false,
            matters: false,
            entries: true
          })),
          "data-cy": "search-time-entries"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Search Time Entries ", -1)]))]),
          _: 1
        }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
          variant: "outlined",
          class: "ml-2",
          disabled: !query.value?.length || query.value.length < 4,
          onClick: _cache[3] || (_cache[3] = $event => search(query.value, {
            clients: true,
            matters: true,
            entries: true
          })),
          "data-cy": "search-all"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Search All ", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        _: 1
      }), _cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "no-print mb-2"
      }, [_createElementVNode("p", {
        class: "text-xs text-gray-600 italic bg-gray-50 pa-2 rounded border border-gray-200"
      }, [_createElementVNode("span", {
        class: "font-medium"
      }, "Note:"), _createTextVNode(" conflict check returns partial matches and ignores special characters in both the search query and the data being searched--searching \"A&B\" will find \"A+B\" and \"Absolute.\" Words separated by spaces will be treated as individual required terms that must ALL be found in the result (but can appear in any order and position)--searching \"Co Act\" will find \"Contract\" and \"Acting Company\". Multiple searches can be done simultaneously by separating queries with a comma \",\" or semicolon \";\" ")])], -1)), componentState.searching ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_v_progress_circular, {
        indeterminate: "",
        size: "20",
        width: "2"
      }), _cache[15] || (_cache[15] = _createElementVNode("span", null, "Searching...", -1))])) : _createCommentVNode("", true), componentState.results.matters || componentState.results.clients || componentState.results.entries ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, "Conflict check run on: " + _toDisplayString(formatDate(componentState.date)), 1), _createElementVNode("span", _hoisted_11, "By: " + _toDisplayString(_unref(me)?.name) + " <" + _toDisplayString(_unref(me)?.email) + ">", 1)]), _createVNode(LlSecondaryButton, {
        size: "small",
        variant: "outlined",
        "prepend-icon": "mdi-printer",
        onClick: printPage
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createVNode(_component_v_row, {
        class: "mt-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_col, {
          cols: "12",
          md: "4",
          class: "pa-2"
        }, {
          default: _withCtx(() => [componentState.results.matters ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("h4", _hoisted_13, _toDisplayString(_unref(me)?.terms?.Matter || 'Matter') + "s", 1), componentState.results.matters.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_14, " No matches ")) : (_openBlock(), _createBlock(_component_v_list, {
            key: 1,
            class: "pa-0",
            density: "compact"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentState.results.matters, matter => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: matter.id,
                class: _normalizeClass([{
                  'v-list-item--active': isDetailActive('matter', matter.id)
                }, "cursor-pointer pa-1 ml-4"]),
                onClick: $event => loadMatterDetail(matter.id)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                  class: "text-sm"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(matter.label), 1)]),
                  _: 2
                }, 1024), _createVNode(_component_v_list_item_subtitle, {
                  class: "ml-6 text-xs"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(matter.client?.label), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["class", "onClick"]);
            }), 128))]),
            _: 1
          }))])) : _createCommentVNode("", true), componentState.results.clients ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[19] || (_cache[19] = _createElementVNode("h4", {
            class: "text-h6 mb-1"
          }, "Clients", -1)), componentState.results.clients.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_16, " No matches ")) : (_openBlock(), _createBlock(_component_v_list, {
            key: 1,
            class: "pa-0",
            density: "compact"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentState.results.clients, client => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: client.id,
                class: _normalizeClass([{
                  'v-list-item--active': isDetailActive('client', client.id)
                }, "cursor-pointer pa-1 ml-4"]),
                onClick: $event => loadClientDetail(client.id)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                  class: "text-sm"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(client.label), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["class", "onClick"]);
            }), 128))]),
            _: 1
          }))])) : _createCommentVNode("", true), componentState.results.entries ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[20] || (_cache[20] = _createElementVNode("h4", {
            class: "text-h6 mb-1"
          }, "Time Entries", -1)), componentState.results.entries.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_18, " No matches ")) : (_openBlock(), _createBlock(_component_v_list, {
            key: 1,
            class: "pa-0",
            density: "compact"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentState.results.entries, entry => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: entry.id,
                class: _normalizeClass([{
                  'v-list-item--active': isDetailActive('entry', entry.id)
                }, "cursor-pointer pa-1 ml-4"]),
                onClick: $event => loadEntryDetail(entry.id)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                  class: "text-sm"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(formatDate(entry.date)) + " - " + _toDisplayString(entry.description), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["class", "onClick"]);
            }), 128))]),
            _: 1
          }))])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_v_col, {
          cols: "12",
          md: "8",
          class: "no-print pa-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [componentState.detailLoading ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "32"
          }), _cache[21] || (_cache[21] = _createElementVNode("p", {
            class: "mt-2"
          }, "Loading details...", -1))])) : componentState.detailType === 'client' && componentState.selectedDetail ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "ma-1"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "pb-2"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(componentState.selectedDetail.label), 1)]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "pa-3"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_table, {
                density: "compact"
              }, {
                default: _withCtx(() => [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[22] || (_cache[22] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Company", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.contact?.companyName), 1)]), _createElementVNode("tr", null, [_cache[23] || (_cache[23] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Contact", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.contact?.first) + " " + _toDisplayString(componentState.selectedDetail.contact?.last), 1)]), componentState.selectedDetail.contact?.email ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [_cache[24] || (_cache[24] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Email", -1)), _createElementVNode("td", null, [_createElementVNode("a", {
                  href: `mailto:${componentState.selectedDetail.contact.email}`,
                  class: "text-blue-600"
                }, _toDisplayString(componentState.selectedDetail.contact.email), 9, _hoisted_22)])])) : _createCommentVNode("", true), componentState.selectedDetail.contact?.phone ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [_cache[25] || (_cache[25] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Phone", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.contact.phone), 1)])) : _createCommentVNode("", true)])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_card_actions, {
              class: "pt-0"
            }, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                variant: "outlined",
                size: "small",
                onClick: _cache[5] || (_cache[5] = $event => navigateToClient(componentState.selectedDetail.id))
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" View Client ", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : componentState.detailType === 'matter' && componentState.selectedDetail ? (_openBlock(), _createBlock(_component_v_card, {
            key: 2,
            class: "ma-1"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "pb-2"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(componentState.selectedDetail.label), 1)]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "pa-3"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_table, {
                density: "compact"
              }, {
                default: _withCtx(() => [_createElementVNode("tbody", null, [componentState.selectedDetail.reference ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [_cache[27] || (_cache[27] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Id", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.reference), 1)])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_cache[28] || (_cache[28] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Client", -1)), _createElementVNode("td", null, [_createElementVNode("a", {
                  href: "#",
                  onClick: _cache[6] || (_cache[6] = $event => loadClientDetail(componentState.selectedDetail.client?.id)),
                  class: "text-blue-600"
                }, _toDisplayString(componentState.selectedDetail.client?.label), 1)])]), componentState.selectedDetail.description ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [_cache[29] || (_cache[29] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Notes", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.description), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.adverse ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [_cache[30] || (_cache[30] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Adverse Parties", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.adverse), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.relatedAdverse ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [_cache[31] || (_cache[31] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Related Adverse Entities", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.relatedAdverse), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.relatedClients ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [_cache[32] || (_cache[32] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Related Client Entities", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.relatedClients), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.opposingCounsel ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [_cache[33] || (_cache[33] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Opposing Counsel", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.opposingCounsel), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.referralSource ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [_cache[34] || (_cache[34] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Referral Source", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.referralSource), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.instructions && _unref(me)?.permissions?.matters?.billingInstructions ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [_cache[35] || (_cache[35] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Billing Instructions", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.instructions), 1)])) : _createCommentVNode("", true), componentState.selectedDetail.custom?.practiceArea ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [_cache[36] || (_cache[36] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Practice Area", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.custom.practiceArea), 1)])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_cache[37] || (_cache[37] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Last Activity", -1)), _createElementVNode("td", null, _toDisplayString(formatDate(componentState.selectedDetail.updated)), 1)]), componentState.selectedDetail.users && componentState.selectedDetail.users.length > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [_cache[38] || (_cache[38] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Users", -1)), _createElementVNode("td", null, [_createElementVNode("ul", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedUsers.value, user => {
                  return _openBlock(), _createElementBlock("li", {
                    key: user.id,
                    class: "text-sm"
                  }, [_createTextVNode(_toDisplayString(user.name) + " ", 1), user.primary ? (_openBlock(), _createElementBlock("span", _hoisted_35, " (Responsible)")) : _createCommentVNode("", true)]);
                }), 128))])])])) : _createCommentVNode("", true)])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_card_actions, {
              class: "pt-0"
            }, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                variant: "outlined",
                size: "small",
                onClick: _cache[7] || (_cache[7] = $event => navigateToMatter(componentState.selectedDetail.id))
              }, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode(" View Matter ", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : componentState.detailType === 'entry' && componentState.selectedDetail ? (_openBlock(), _createBlock(_component_v_card, {
            key: 3,
            class: "ma-1"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "pb-2"
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("Time Entry", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "pa-3"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_table, {
                density: "compact"
              }, {
                default: _withCtx(() => [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[41] || (_cache[41] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Date", -1)), _createElementVNode("td", null, _toDisplayString(formatDate(componentState.selectedDetail.date)), 1)]), _createElementVNode("tr", null, [_cache[42] || (_cache[42] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "User", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.account?.initials || componentState.selectedDetail.account?.name), 1)]), _createElementVNode("tr", null, [_cache[43] || (_cache[43] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Description", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.description), 1)]), _createElementVNode("tr", null, [_cache[44] || (_cache[44] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Hours", -1)), _createElementVNode("td", null, _toDisplayString(componentState.selectedDetail.hours), 1)]), componentState.selectedDetail.matter?.client ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [_cache[45] || (_cache[45] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Client", -1)), _createElementVNode("td", null, [_createElementVNode("a", {
                  href: "#",
                  onClick: _cache[8] || (_cache[8] = _withModifiers($event => loadClientDetail(componentState.selectedDetail.matter.client.id), ["prevent"])),
                  class: "text-blue-600 cursor-pointer"
                }, _toDisplayString(componentState.selectedDetail.matter.client.label), 1)])])) : _createCommentVNode("", true), componentState.selectedDetail.matter ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [_cache[46] || (_cache[46] = _createElementVNode("td", {
                  class: "font-weight-bold"
                }, "Matter", -1)), _createElementVNode("td", null, [_createElementVNode("a", {
                  href: "#",
                  onClick: _cache[9] || (_cache[9] = _withModifiers($event => loadMatterDetail(componentState.selectedDetail.matter.id), ["prevent"])),
                  class: "text-blue-600 cursor-pointer"
                }, _toDisplayString(componentState.selectedDetail.matter.label), 1)])])) : _createCommentVNode("", true)])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : componentState.results.matters || componentState.results.clients || componentState.results.entries ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[47] || (_cache[47] = [_createElementVNode("p", {
            class: "text-body-1"
          }, "Click on a search result to view more details", -1)]))])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};